<template>
  <div>
    <div v-if="modal=='infoReserva'" class="modal fade w-50 mx-auto" id="infoReserva" tabindex="-1" role="dialog"
         aria-labelledby="infoReservaLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoReservaLabel" v-text="idioma.antes"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p :key="index" v-for="(txt, index) in idioma.textoAntes">{{ txt }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal información fechas -->
    <div v-if="modal=='infoFechas'" class="modal fade w-50 mx-auto" id="infoFechas" tabindex="-1" role="dialog"
         aria-labelledby="infoFechasLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoFechasLabel" v-text="idioma.fechas"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p :key="index" v-for="(txt, index) in idioma.textoFechas">{{ txt }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal información plazas -->
    <div v-if="modal=='infoPlazas'" class="modal fade w-50 mx-auto" id="infoPlazas" tabindex="-1" role="dialog"
         aria-labelledby="infoPlazasLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoPlazasLabel" v-text="idioma.plazas"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p :key="index" v-for="(txt, index) in idioma.textoPlazas">{{ txt }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal información sobre los servicios -->
    <div v-if="modal=='servicesInfo'" class="modal fade w-50 mx-auto" id="infoServicios" tabindex="-1" role="dialog"
         aria-labelledby="infoServiciosLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoServiciosLabel" v-text="idioma.infoCabecera"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p v-text="idioma.info"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal información adelanto de la reserva -->
    <div v-if="modal=='infoAdelanto'" class="modal fade w-50 mx-auto" id="infoAdelanto" tabindex="-1" role="dialog"
         aria-labelledby="infoAdelantoLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoAdelantoLabel" v-text="idioma.totalAdelanto"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p :key="index" v-for="(txt, index) in idioma.textoAdelanto">{{ txt }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal información sobre la tarjeta federativa -->
    <div v-if="modal=='infoTarjeta'" class="modal fade w-50 mx-auto" id="infoTarjeta" tabindex="-1" role="dialog"
         aria-labelledby="infoTarjetaLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoTarjetaLabel" v-text="idioma.infoTarjetaCabecera"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p v-text="idioma.infoTarjeta"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal condiciones de la reserva -->
    <div v-if="modal=='infoCondiciones'" class="modal fade w-50 mx-auto" id="condiciones" tabindex="-1" role="dialog"
         aria-labelledby="condicionesLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="condicionesLabel" v-text="idioma.legal.condiciones.titulo"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5 v-text="idioma.legal.condiciones.generales.titulo"></h5>
            <p :key="`g${idx}`" v-for="(txt, idx) in idioma.legal.condiciones.generales.texto">
              {{ txt }}</p>
            <hr>
            <h5 v-text="idioma.legal.condiciones.anticipo.titulo"></h5>
            <p :key="`i${idx}`" v-for="(txt, idx) in idioma.legal.condiciones.anticipo.inicio">
              {{ txt }}</p>
            <ul>
              <li :key="`${idx}`" v-for="(txt, idx) in idioma.legal.condiciones.anticipo.lista">{{ txt }}
              </li>
            </ul>
            <p :key="`${idx}`" v-for="(txt, idx) in idioma.legal.condiciones.anticipo.fin">{{ txt }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal información legal -->
    <div v-if="modal=='legal'" class="modal fade w-50 mx-auto" id="legal" tabindex="-1" role="dialog"
         aria-labelledby="legalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="legalLabel" v-text="idioma.tituloGeneral"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ol class="legales">
              <li class="font-weight-bold">
                <u v-text="idioma.info.titulo"></u>
                <p :key="infIdx" v-for="(infoTxt, infIdx) in idioma.info.texto">{{ infoTxt }}</p>
              </li>
              <li class="font-weight-bold">
                <u v-text="idioma.proteccion.titulo"></u>
                <p :key="proIdx" v-for="(proTxt, proIdx) in idioma.proteccion.texto">{{ proTxt }}</p>
              </li>
              <li class="font-weight-bold">
                <u v-text="idioma.limitacion.titulo"></u>
                <p :key="limIdx" v-for="(limTxt, limIdx) in idioma.limitacion.texto">{{ limTxt }}</p>
              </li>
              <li class="font-weight-bold">
                <u v-text="idioma.propiedad.titulo"></u>
                <p :key="protIdx" v-for="(protTxt, protIdx) in idioma.propiedad.texto">{{ protTxt }}</p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de cancelar la reserva -->
    <div v-if="modal=='cancelar'" class="modal fade w-50 mx-auto" id="cancelar" tabindex="-1" role="dialog"
         aria-labelledby="cancelarLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="cancelarLabel" v-text="idioma.tituloGeneral"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h3>{{ idioma.textoCancelar }}</h3>
          </div>
          <div class="modal-footer">
            <button type="button" @click="confirma" data-dismiss="modal" class="cancelar margintop20">
              {{ idioma.confirmarCancelar }}
            </button>
            <button class="floatRight margintop20" data-dismiss="modal">{{ idioma.cerrarCancelar }}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modal=='registrado'" class="modal fade w-50 mx-auto" id="registrado" tabindex="-1" role="dialog"
         aria-labelledby="registradoLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-center w-100 text-info" id="registradoLabel" v-text="idioma.tituloExiste"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h3 class="text-center">{{ idioma.existe }}</h3>
          </div>
          <span class="text-center">
            <a href="https://alberguesyrefugios.com/recuperar" target="_blank">
              <small>{{ idioma.olvido }}</small>
            </a>
          </span>
          <div class="modal-footer">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalsController',
  props: ['idioma', 'modal'],
  methods: {
    confirma () {
      try {
        this.$emit('cancelar')
      } catch (e) {
        console.log(err)
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalsController.vue